import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import SkeletonBase from './SkeletonBase';
import { getSize } from './skeletonBaseUtils';
const SkeletonTextWrapper = styled.div.withConfig({
  displayName: "SkeletonText__SkeletonTextWrapper",
  componentId: "x6qo55-0"
})(["position:relative;width:", ";"], ({
  width
}) => getSize(width));
const SkeletonTextInner = styled(SkeletonBase).withConfig({
  displayName: "SkeletonText__SkeletonTextInner",
  componentId: "x6qo55-1"
})(["height:0.75em;left:0;position:absolute;top:50%;transform:translateY(-50%);width:100%;"]);

const SkeletonText = (_ref) => {
  let {
    width = '100%',
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["width", "className"]);

  return /*#__PURE__*/_jsxs(SkeletonTextWrapper, {
    width: width,
    className: className,
    children: ["\xA0", /*#__PURE__*/_jsx(SkeletonTextInner, Object.assign({}, rest))]
  });
};

SkeletonText.displayName = 'SkeletonText';
export default SkeletonText;